export const environment = {
    production: false,
    homeLink: 'https://utimaco.com/products/as-a-service',
    loginLink: 'https://portal.dev.services.utimaco.com/',
    formHandlerUrl: 'https://taas-customer-registration-api.aks.taas-dev-gwc.az.utimaco.cloud/api/v1/registration/customers'
};